import * as React from "react";
function SvgAlert(props) {
  return <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M15.99 10.65v5.33m0 5.33H16m-.01 8.01c7.36 0 13.33-5.97 13.33-13.33S23.35 2.66 15.99 2.66 2.66 8.62 2.66 15.99s5.97 13.33 13.33 13.33z" strokeWidth={1.5} stroke="currentColor" vectorEffect="non-scaling-stroke" strokeLinecap="round" strokeLinejoin="round" /></svg>;
}
export default SvgAlert;